export enum GroupByNoDefault {
    ID_CARGA = 'ID_CARGA',
    CTE = 'CTE',
}
